import { render, staticRenderFns } from "./BeButton.vue?vue&type=template&id=42833d16&scoped=true"
import script from "./BeButton.vue?vue&type=script&lang=js"
export * from "./BeButton.vue?vue&type=script&lang=js"
import style0 from "./BeButton.vue?vue&type=style&index=0&id=42833d16&prod&lang=css"
import style1 from "./BeButton.vue?vue&type=style&index=1&id=42833d16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42833d16",
  null
  
)

export default component.exports